import React from 'react';
import { withRouter } from 'react-router-dom';
import LoginForm from '../components/sections/LoginForm';
import { TokenService } from '../api/tokenService';

class Login extends React.Component {
  componentDidMount() {
    // ✅ check if already logged in
    const token = TokenService.getLocalAccessToken
      ? TokenService.getLocalAccessToken()
      : localStorage.getItem('accessToken'); // fallback if you don't have the method

    if (token) {
      // already logged in → send to private page (you can use "/" or "/secondary")
      this.props.history.replace('/');
    }
  }

  render() {
    return <LoginForm className="illustration-section-01" />;
  }
}

export default withRouter(Login);
